import { render, staticRenderFns } from "./AptListManage.vue?vue&type=template&id=3d5ac47f&scoped=true"
import script from "./AptListManage.vue?vue&type=script&lang=js"
export * from "./AptListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ac47f",
  null
  
)

export default component.exports